// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    URLPrefix: 'https://gambo.app/api/test',
    appVersion: '1.4',

    apiKey: 'AIzaSyAWM2ZgEKVwo4Jp0AIDpWeuK5LkWAUkObA',
    authDomain: 'gambo-231511.firebaseapp.com',
    databaseURL: 'https://gambo-231511.firebaseio.com',
    projectId: 'gambo-231511',
    storageBucket: 'gambo-231511.appspot.com',
    messagingSenderId: '253151794875',
    appId: '1:253151794875:web:4915afeb9d0ec7ac88fb9e',
    measurementId: 'G-Z1XKG2WRQT',

    wsGameURL: 'wss://gambo.app/ws/game/test',
    wsRoomURL: 'wss://gambo.app/ws/room/test'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
